export default __webpack_public_path__ + "static/media/frame_dark_brown_new.918b3f68.png";